// Get My Creators Connected Scroll
export const GET_MY_CREATORS_CONNECTED_SCROLL_REQUEST = 'GET_MY_CREATORS_CONNECTED_SCROLL_REQUEST';
export const GET_MY_CREATORS_CONNECTED_SCROLL_DONE = 'GET_MY_CREATORS_CONNECTED_SCROLL_DONE';
export const GET_MY_CREATORS_CONNECTED_SCROLL_FAILED = 'GET_MY_CREATORS_CONNECTED_SCROLL_FAILED';
export const GET_MY_CREATORS_CONNECTED_SCROLL_RESET = 'GET_MY_CREATORS_CONNECTED_SCROLL_RESET';

export const MY_CREATORS_CONNECTED_SCROLL_OPTIMISTIC_REMOVE = 'MY_CREATORS_CONNECTED_SCROLL_OPTIMISTIC_REMOVE';
export const MY_CREATORS_CONNECTED_SCROLL_OPTIMISTIC_ADD = 'MY_CREATORS_CONNECTED_SCROLL_OPTIMISTIC_ADD';

// Refresh
export const REFRESH_MY_CREATORS_CONNECTED_SCROLL_REQUEST = 'REFRESH_MY_CREATORS_CONNECTED_SCROLL_REQUEST';
export const REFRESH_MY_CREATORS_CONNECTED_SCROLL_DONE = 'REFRESH_MY_CREATORS_CONNECTED_SCROLL_DONE';
export const REFRESH_MY_CREATORS_CONNECTED_SCROLL_FAILED = 'REFRESH_MY_CREATORS_CONNECTED_SCROLL_FAILED';

// Operations
export const TOGGLE_MY_CREATORS_CONNECTED_SCROLL = 'TOGGLE_MY_CREATORS_CONNECTED_SCROLL';
export const TOGGLE_ALL_MY_CREATORS_CONNECTED_SCROLL = 'TOGGLE_ALL_MY_CREATORS_CONNECTED_SCROLL';
export const SET_MY_CREATORS_CONNECTED_SCROLL_FILTER = 'SET_MY_CREATORS_CONNECTED_SCROLL_FILTER';
export const SET_MY_CREATORS_CONNECTED_SCROLL_ALL_FILTERS = 'SET_MY_CREATORS_CONNECTED_SCROLL_ALL_FILTERS';
export const CLEAR_MY_CREATORS_CONNECTED_SCROLL_FILTERS = 'CLEAR_MY_CREATORS_CONNECTED_SCROLL_FILTERS';
export const MY_CREATORS_CONNECTED_SCROLL_SET_PAGE = 'MY_CREATORS_CONNECTED_SCROLL_SET_PAGE';
